import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Col, Container } from 'react-bootstrap'
import MetabolicPlanTable from './MetabolicPlanTable'
import MetabolicPlanForm from './MetabolicPlanForm'
// import { ResizableBox, ResizeHandle } from 'react-resizable'
import 'react-resizable/css/styles.css'
import MetabolicPlanBasicInfo from './MetabolicPlanBasicInfo'
import MetabolicPlanClosed from './MetabolicPlanClosed'
// import 'antd/dist/antd.css'

const MetabolicPlan = ({ currentUser, setWarning, warning, setQrcode }) => {
  const [currentPatient, setCurrentPatient] = useState(null)

  // const [width, setWidth] = useState((window.innerWidth - 300) / 2)
  // const minWidth = 400
  // TODO:
  const [caseModalShow, setCaseModalShow] = useState(false)
  const [basicInfoModalShow, setBasicInfoModalShow] = useState(false)
  const [caseClosedModalShow, setCaseClosedModalShow] = useState(false)

  return (
    <>
      <Helmet>
        <title>代謝計畫 | HA! CRM</title>
      </Helmet>
      <div className="containerOverflow">
        <Container className="metabolicPlan d-flex">
          <Col style={{ padding: 0 }}>
            <MetabolicPlanTable
              currentPatient={currentPatient}
              setCurrentPatient={setCurrentPatient}
              caseModalShow={caseModalShow}
              setCaseModalShow={setCaseModalShow}
              setBasicInfoModalShow={setBasicInfoModalShow}
            />
          </Col>
          {basicInfoModalShow && (
            <MetabolicPlanBasicInfo
              currentPatient={currentPatient}
              setCurrentPatient={setCurrentPatient}
              setBasicInfoModalShow={setBasicInfoModalShow}
              basicInfoModalShow={basicInfoModalShow}
              caseModalShow={caseModalShow}
              setCaseModalShow={setCaseModalShow}
              setQrcode={setQrcode}
            />
          )}

          {caseClosedModalShow && (
            <MetabolicPlanClosed
              currentPatient={currentPatient}
              caseClosedModalShow={caseClosedModalShow}
              setCaseClosedModalShow={setCaseClosedModalShow}
              setCaseModalShow={setCaseModalShow}
              setWarning={setWarning}
            />
          )}

          {caseModalShow && (
            <MetabolicPlanForm
              currentPatient={currentPatient}
              setCaseModalShow={setCaseModalShow}
              caseModalShow={caseModalShow}
              warning={warning}
              setWarning={setWarning}
              setQrcode={setQrcode}
              setCaseClosedModalShow={setCaseClosedModalShow}
            />
          )}
        </Container>
      </div>
    </>
  )
}

export default MetabolicPlan
